module.exports = "/_next/static/images/bc5245353e826a044a5dc2d22db59819-smile-icon.svg.webp";